import { combineReducers } from "redux";
import auth from "./_slices/auth";
import response from "./_slices/response";
import cart from "./_slices/cart";
import txn from "./_slices/txn";
import yoti from "./_slices/yoti";
import vendLogs from "./_slices/vendLogs";

const rootReducer = combineReducers({ auth, response, cart, txn, yoti, vendLogs });
export default rootReducer;
